import { IntegrationType, NonSensitiveFlightRecordConnectedAccount } from "@nova/schemas"
import { AccountsByIntegrationType } from "features/data-management/pilot-tracking/PilotTrackingConnectionsContext"
import { integrationSectionByIntegrationType } from "./constants"
import { FC } from "react"
import classNames from "classnames"

export function IntegrationSection<K extends IntegrationType>({
    type,
    accounts,
    i,
}: {
    type: K
    accounts: AccountsByIntegrationType[K]
    i: number
}) {
    const Section = integrationSectionByIntegrationType[type] as
        | FC<{ accounts: NonSensitiveFlightRecordConnectedAccount<K>[] }>
        | undefined
    if (!Section || !accounts?.length) return null
    return (
        <div className={classNames({ "border-t border-gray-700 pt-8": i > 0 })}>
            <Section accounts={accounts} />
        </div>
    )
}
